import { createClientFileStorageModule } from '@hendrx/file-storage-cloudinary/client';
import { createClientModules } from '@hendrx/modules';

createClientModules({
  fileStorage: createClientFileStorageModule
});
